// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-layouts----layout-module---wrapper---1UBDS","content":"src-layouts----layout-module---content---1ar7r","logo":"src-layouts----layout-module---logo---2pJRX","privacyContainer":"src-layouts----layout-module---privacyContainer---1VNpM","privacyContainerShow":"src-layouts----layout-module---privacyContainerShow---qmRJ9 src-layouts----layout-module---privacyContainer---1VNpM","privacy":"src-layouts----layout-module---privacy---OYW8x"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout.module.css
// module id = 325
// module chunks = 114276838955818